import Error404 from '../../containers/Errors/error404';
import Error500 from '../../containers/Errors/error500';

const errorRoutes = [
  {
    path: "/*",
    exact: true,
    auth: false,
    component: Error404
  },
  {
    path: "/500",
    exact: true,
    auth: false,
    component: Error500
  }
];

export default errorRoutes;


// WEBPACK FOOTER //
// ./src/routes/modules/errors.jsx